import BaseModule from "~/vuex/modules/base-module";

let Permissions = {...BaseModule};

Permissions.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/permissions';

    return state;
};
export default Permissions;
